<section class="breadcrumbSection">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a [routerLink]="['/']"> <mat-icon>home</mat-icon>&nbsp;&nbsp;Home </a>
    </li>
    <li *ngFor="let breadcrumb of breadcrumbs; let i=index" class="breadcrumb-item breadcrumb-url-list">
      <a *ngIf="!(breadcrumbs.length - 1 === i)"> <!--[routerLink]="'/' + breadcrumb.url" -->
        {{ breadcrumb.label.title }}
      </a>
      <a *ngIf="(breadcrumbs.length - 1 === i)"> {{ breadcrumb.label.title }} </a>
    </li>
  </ol>
</section>
